module.exports = __webpack_public_path__ + "static/img/news_14.5212867.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_14.jpg
// module id = VQLj
// module chunks = 2